import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { componentGroups } from '../config';
import { IComponentGroup, IComponentDef } from '../shared/interfaces';
import { SFSchema } from '@delon/form';

@Component({
  selector: 'app-form-designer',
  templateUrl: './form-designer.component.html',
  styleUrls: ['form-designer.component.less']
})
export class FormDesignerComponent implements OnInit {
  logo = 'assets/logo.png';

  /** 所有控件 */
  componentGroups: IComponentGroup[] = [];

  /** 表单控件 */
  rootComponent: IComponentDef = {
    id: 'widget-form',
    type: 'form',
    widget: 'layout-form',
    labelPosition: 'left',
    labelSuffix: '：',
    gutter: 0,
    children: [],
    // 表单独有配置
    formLayout: 'horizontal',
    formSize: 'default',
    formBtn: true,
    formBtnSubmit: true,
    formBtnSubmitText: '提交',
    formBtnReset: true,
    formBtnResetText: '重置',
    bordered: false
  };

  /** 当前选中控件 */
  selectComponent: IComponentDef | null;

  /** 默认值 */
  defaultValues: any;

  /** 撤销和重做 */
  undoRedo: boolean;

  /** 历史记录 */
  history = {
    index: 0,
    maxStep: 20,
    steps: []
  };

  /** 工具条 */
  toolbar: string[] = ['import', 'generate', 'preview', 'previewBorderd', 'clear'];

  /** 导入json */
  importJson: string;
  importJsonVisible: boolean;

  /** json预览 */
  previewJson: string;
  previewJsonVisible: boolean;

  /** 预览表单 */
  previewForm: SFSchema;
  previewFormVisible: boolean;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.componentGroups = [...componentGroups];
  }

  /** 运行 */
  run() { }

  /** 显示json */
  showJson() { }

  /** 导出vue文件 */
  download() { }

  /** 复制代码 */
  copy() { }

  /** 清空 */
  empty() { }

  handleSelectWidget(widget: IComponentDef, i: number) {
    this.selectComponent = widget;
  }

  /** 撤销 */
  handleUndo() { }

  /** 重做 */
  handleRedo() { }

  /** 导入JSON */
  handleImportJson() {
    this.importJsonVisible = true;
  }

  /** 生成JSON */
  handleGenerateJson() {
    this.previewJson = null;
    this.selectComponent = null;
    this.previewJsonVisible = true;
    this.previewJson = JSON.stringify(this.rootComponent, null, '\t');
  }

  /** 预览 */
  handlePreview() {
    this.previewJson = null;
    this.selectComponent = null;
    this.previewFormVisible = true;
    this.previewJson = JSON.stringify(this.rootComponent, null, '\t');
  }

  /** 清空 */
  handleClear() {
    this.selectComponent = null;
    this.rootComponent.children = [];
  }

  /** 关闭导入json面板 */
  closeImportJson() {
    try {
      const component = JSON.parse(this.importJson);
      if (component) {
        this.rootComponent = component;
      }
    } catch { }
    this.importJsonVisible = false;
  }

  /** 获取当前json */
  getJson() {
    return (this.previewJson = JSON.stringify(this.rootComponent, null, '\t'));
  }
  /** 使用接口返回值渲染form组件 */
  importJsonByApi(val) {
    this.importJson = val;
    this.closeImportJson();
  }
  /** 关闭预览表单json面板 */
  closePreviewJson() {
    this.previewJsonVisible = false;
    this.previewJson = null;
  }

  /** 关闭预览表单面板 */
  closePreviewForm() {
    this.previewForm = null;
    this.previewFormVisible = false;
  }

  sfSubmit(value) {
    console.log(value, 'sfSubmit');
  }
  sfReset(value) {
    console.log(value, 'sfReset');
  }
}
